import TYPES from '@/modules/shared/types';

// Domain
import { InvestorProfileInvestmentExperienceRepository }
  from '../../domain/repositories/investor-profile-investment-experience-repository';
import { InvestorProfileInvestmentExperienceDto }
  from '../../domain/dtos/investor-profile-investment-experience-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class InvestorProfileInvestmentExperienceHttpRepository
implements InvestorProfileInvestmentExperienceRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-profile/investment-experience/{investor_profile_id}/`;

  update(payload: InvestorProfileInvestmentExperienceDto): Promise<void> {
    return new Promise((resolve, reject) => {
      const { investor_profile_id, investment_experience } = payload;
      this.http_connector.execute(this.endpoint.replace('{investor_profile_id}', investor_profile_id!), 'PATCH', { investment_experience })
        .then((response) => {
          if (response.ok) {
            resolve();
          } else {
            response.json().then(
              ({ message }) => {
                reject(new Error(message));
              },
            );
          }
        })
        .catch(reject);
    });
  }
}
